import { render, staticRenderFns } from "./RegisterDone.vue?vue&type=template&id=0bb803e2&"
import script from "./RegisterDone.vue?vue&type=script&lang=js&"
export * from "./RegisterDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports